module.exports = __webpack_public_path__ + "img/filter-container.85d67aaa.png";